import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { CollapseType } from '@meitu/saas-editor-ui';

export interface IBrushCollapseModel {
    /**
     * 来源信息
     */
    from: CollapseType | null;

    /**
     * 设置来源信息
     */
    setFrom: (payload: CollapseType | null) => void;
}

const useBrushCollapseModel = create<IBrushCollapseModel>()(
    immer((set) => ({
        from: null,

        setFrom: (payload) =>
            set((state) => {
                state.from = payload;
            }),
    })),
);

export { useBrushCollapseModel };
export const getBrushCollapseModel = () => useBrushCollapseModel.getState();
